import React, { useContext } from "react";
import { Row, Col, FormGroup, FormControl, FormLabel, Form } from "react-bootstrap";
import { useWizard } from "./WizardContext";
import Select from "react-select";
import { useGuestContext } from "../../../../contexts/GuestContext";
import LanguageToggle from "../LanguageToggle";
import SweetAlert from "react-bootstrap-sweetalert";
import cuteMonk1 from "../../../../assets/img/baolinPrivate/cute_monk1.png";
import cuteMonk2 from "../../../../assets/img/baolinPrivate/cute_monk2.png";
import cuteVege1 from "../../../../assets/img/baolinPrivate/cute_vege1.png";
import cuteVege2 from "../../../../assets/img/baolinPrivate/cute_vege2.png";

const Step1 = React.forwardRef((props, ref) => {
  const {
    firstname, setFirstname,
    lastname, setLastname,
    chinesename, setChinesename,
    email, setEmail,
    phone, setPhone,
    relatives, setRelatives,
    timeslot, setTimeslot

  } = useWizard();

  const { language } = useGuestContext();

  //define error messages
  const [firstnameError, setFirstnameError] = React.useState(null);
  const [lastnameError, setLastnameError] = React.useState(null);
  const [emailError, setEmailError] = React.useState(null);
  const [phoneError, setPhoneError] = React.useState(null);
  const [chinesenameError, setChinesenameError] = React.useState(null);
  const [timeslotError, setTimeslotError] = React.useState(null);
  const [relativesError, setRelativesError] = React.useState(null);

  //state for warning alert
  const [alertState, setAlertState] = React.useState(null);

  const handleCheckboxChange = (event, setSession) => {
    setSession(event.target.checked);
  };

  const handleRelativesChange = (option) => {
    setRelatives(option.value);
    // Clear any existing error when user selects a value
    setRelativesError(null);
    // Show warning alert when user selects a number
    setAlertState(
      <SweetAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={language === "English" ? "Reminder" : "提醒"}
        onConfirm={() => setAlertState(null)}
        confirmBtnBsStyle="success"
        confirmBtnText={language === "English" ? "I Understand" : "我明白了"}
      >
        <strong>
          {language === "English"
            ? "Please make sure the total size of your group should also include yourself."
            : "参加总人数也包括您自己本人"
          }
        </strong>
      </SweetAlert>
    );
  };

  const handleNameChange = (value, setName, setError, isChineseName = false) => {
    // Regular expression for non-Chinese names: allows letters, spaces, hyphens, and apostrophes
    const nameRegex = /^[A-Za-z\s'-]+$/;
    // Regular expression for Chinese names: allows Chinese characters (including simplified and traditional), spaces, and common name characters
    const chineseNameRegex = /^[\u4e00-\u9fa5\s·]+$/;

    let isValid = isChineseName ? chineseNameRegex.test(value) : nameRegex.test(value);

    if (!isValid && value !== "") {
      setError(
        <small className="text-danger">
          {language === "English"
            ? isChineseName
              ? "Invalid characters. Only Chinese characters are allowed."
              : "Invalid characters. Only letters, spaces, hyphens, and apostrophes are allowed."
            : isChineseName
              ? "包含无效字符。只允许中文字符。"
              : "包含无效字符。只允许字母、空格、连字符和撇号。"
          }
        </small>
      );
    } else {
      setError(null);
    }
    setName(value);
  };

  const isValidated = () => {
    console.log("hey");
    //check firstname
    (firstname === null || firstname.trim() === "")
      ? setFirstnameError(
        <small className="text-danger">{language === "English" ? "First name is required." : "未填寫英文名"}</small>
      )
      : setFirstnameError(null);

    //check lastname
    (lastname === null || lastname.trim() === "")
      ? setLastnameError(
        <small className="text-danger">{language === "English" ? "Last name is required." : "未填寫英文姓"}</small>
      )
      : setLastnameError(null);

    (phone === null || phone.trim() === "")
      ? setPhoneError(
        <small className="text-danger">{language === "English" ? "Please enter a contact phone number." : "請填息聯繫電話以方便聯絡."}</small>
      )
      : setPhoneError(null);

    //check relatives (group size)
    (relatives === null || relatives === undefined)
      ? setRelativesError(
        <small className="text-danger">{language === "English" ? "Please select group size." : "請選擇隨行人數"}</small>
      )
      : setRelativesError(null);

    var fn = !(firstname === null || firstname.trim() === "");
    var ln = !(lastname === null || lastname.trim() === "");
    var ph = !(phone === null || phone.trim() === "");
    var rel = !(relatives === null || relatives === undefined);
    var valid = fn && ln && ph && rel;
    return valid;
  };

  React.useImperativeHandle(ref, () => ({
    isValidated: () => {
      console.log("Step 1 validation");
      return isValidated();
    },
  }));


  const relativesOptions = Array.from({ length: 15 }, (_, i) => ({
    value: i + 1,
    label: `${i + 1}`,
  }));

  const timeslotOptions = [
    { value: "morning", label: language === "English" ? "Morning 9:30am-12:30pm" : "上午 9:30am-12:30pm" },
    { value: "afternoon", label: language === "English" ? "Afternoon 1:30pm-4:30pm" : "下午 1:30pm-4:30pm" },
    { value: "full_day", label: language === "English" ? "Full Day 9:30am-4:30pm" : "全天 9:30am-4:30pm" },
  ];


  return (
    <>
      {alertState}
      <div className="wizard-step" ref={ref}>
        <p className="text-center mb-2 font-weight-bold">
          <img src={cuteMonk1} alt="Company Logo" width="40" className="mr-3" />
          {language === "English" ? "Personal Information" : "請提供以下個人信息"}
          <img src={cuteMonk2} alt="Company Logo" width="40" className="ml-3" />
        </p>
        <hr />
        <LanguageToggle />
        <hr />
        <Row>
          <Col md={{ span: 5, offset: 1 }}>
            <FormGroup>
              <FormLabel>
                {language === "English" ? "First Name (Required)" : "英 文 名（必填）"}<span className="text-danger">*</span>
              </FormLabel>
              <FormControl
                type="text"
                name="firstname"
                placeholder="ex: Mike"
                maxLength="30"
                value={firstname}
                onChange={(event) => handleNameChange(event.target.value, setFirstname, setFirstnameError)}
              />
              {firstnameError}
            </FormGroup>
          </Col>
          <Col md={5}>
            <FormGroup>
              <FormLabel>
                {language === "English" ? "Last Name (Required)" : "英 文 姓（必填）"}<span className="text-danger">*</span>
              </FormLabel>
              <FormControl
                type="text"
                name="lastname"
                maxLength="30"
                placeholder="ex: Andrew"
                value={lastname}
                onChange={(event) => handleNameChange(event.target.value, setLastname, setLastnameError)}
              />
              {lastnameError}
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={{ span: 5, offset: 1 }}>
            <FormGroup>
              <FormLabel>
                {language === "English" ? "Chinese Name" : "中 文 姓 名"}
              </FormLabel>
              <FormControl
                type="text"
                name="chinesename"
                maxLength="30"
                placeholder={language === "English" ? "ex: Wukong" : "ex：悟空"}
                value={chinesename}
                onChange={(event) => handleNameChange(event.target.value, setChinesename, setChinesenameError, true)}
              />
              {chinesenameError}
            </FormGroup>
          </Col>
          <Col md={{ span: 5 }}>
            <FormGroup>
              <FormLabel>
                {language === "English" ? "Phone Number (Required for contact)" : "電 話 號 碼（必填，聯絡用）"} <span className="text-danger">*</span>
              </FormLabel>
              <FormControl
                type="number"
                name="phone"
                maxLength="30"
                placeholder="ex: 0433233343"
                value={phone}
                onChange={(event) => setPhone(event.target.value)}
              />
              {phoneError}
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={{ span: 5, offset: 1 }}>
            <FormGroup>
              <FormLabel>
                {language === "English" ? "Email (optional for contact)" : "電 子 郵 件（聯絡用）"}
              </FormLabel>
              <FormControl
                type="email"
                name="email"
                maxLength="50"
                placeholder="ex: wukong@baolin.com"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />
              {emailError}
            </FormGroup>
          </Col>
          <Col md={{ span: 5 }}>
            <FormGroup>
              <FormLabel>
                {language === "English" ? "Group Size (People Coming Along and yourself)" : "隨行人数（包括自己）"} <span className="text-danger">*</span>
              </FormLabel>
              <Select
                className="react-select primary"
                classNamePrefix="react-select"
                name="relativesSelect"
                value={relativesOptions.find((option) => option.value === relatives)}
                onChange={handleRelativesChange}
                options={relativesOptions}
                placeholder={language === "English" ? "Select number" : "选择人数"}
              />
              {relativesError}
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col md={{ span: 5, offset: 1 }}>
            <FormGroup>
              <FormLabel>
                {language === "English" ? "Time slot you would like to join" : "參加時段"}
              </FormLabel>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {timeslotOptions.map((option) => (
                  <div
                    key={option.value}
                    onClick={() => {
                      setTimeslot(option.value);
                      setTimeslotError(null);
                    }}
                    style={{
                      padding: '12px 20px',
                      border: timeslot === option.value ? '2px solid #FFA534' : '1px solid #ccc',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      backgroundColor: timeslot === option.value ? '#FFA534' : 'white',
                      color: timeslot === option.value ? 'white' : '#333',
                      fontWeight: timeslot === option.value ? 'bold' : 'normal',
                      fontSize: '16px',
                      textAlign: 'center',
                      transition: 'all 0.2s',
                      boxShadow: timeslot === option.value ? '0 2px 8px rgba(255, 165, 52, 0.3)' : 'none'
                    }}
                  >
                    {option.label}
                  </div>
                ))}
              </div>
            </FormGroup>
          </Col>
        </Row>
      </div>
    </>
  );
});

export default Step1;
